import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { defineComponent, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { ModelBase, Column } from 'loca-boot-core';
import { Device, Env, JsBridge } from '@nio-pow/mfe-vue3';
import envConfig from '@/utils/envConfig';
import { fetchBackend } from '@/utils/fetch';
const EMPLOYEE_DIFFERENCE_CN = 'CN' // 员工来源：中国
;
const EMPLOYEE_DIFFERENCE_EU = 'EU' // 员工来源：欧洲
;
/**
 * https://apidoc.nioint.com/project/8100/interface/api/778681
 */ class UserEmployeeModel extends ModelBase {
}
_ts_decorate([
    Column(),
    _ts_metadata("design:type", String)
], UserEmployeeModel.prototype, "employeeDifference", void 0);
const apiGetUserDifference = ()=>{
    return fetchBackend.get('/pe/powerpro/v1/user/difference', {
        wrapper: UserEmployeeModel
    });
};
export default defineComponent({
    name: 'ErrorPage',
    setup () {
        const route = useRoute();
        const isError = ()=>{
            if (route.query.auth) {
                return false;
            }
            return true;
        };
        const { t } = useI18n();
        const state = reactive({
            loading: false,
            isInternational: Env.isInternational(),
            isEuropaLabor: false,
            isFeishuPC: Device.isFeishuPC(),
            isFeishu: Device.isFeishu(),
            internalDocUrl: 'https://nio.feishu.cn/docs/doccnZvn8oX1K9IZhJmtKubMkng',
            internationalDocUrl: 'https://nio.feishu.cn/docx/PNpQd7mmRouwqsxE7xhcFRWvnKg',
            isPc: !Device.isMobile(),
            appId: envConfig.APP_ID,
            env: Env.getEnv(),
            // en是国外portal，zh是国内portal
            lang: Env.isInternational() ? 'en' : 'zh',
            config: {
                zh: {
                    // 国内portal
                    [EMPLOYEE_DIFFERENCE_CN]: {
                        // 员工来源:CN的人，默认
                        local: 'https://laputa-test.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        dev: 'https://laputa-dev.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        test: 'https://laputa-test.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        stg: 'https://laputa-stg.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        prod: 'https://laputa.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID
                    }
                },
                en: {
                    // 国外portal
                    [EMPLOYEE_DIFFERENCE_EU]: {
                        // 员工来源:eu的人
                        local: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=en&app_id=' + envConfig.APP_ID,
                        dev: 'https://laputa-dev-eu.nioint.com/authorityApply.html?lang=en&app_id=' + envConfig.APP_ID,
                        test: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=en&app_id=' + envConfig.APP_ID,
                        stg: 'https://laputa-stg-eu.nioint.com/authorityApply.html?lang=en&app_id=' + envConfig.APP_ID,
                        prod: 'https://laputa-eu.nioint.com/authorityApply.html?lang=en&app_id=' + envConfig.APP_ID
                    },
                    [EMPLOYEE_DIFFERENCE_CN]: {
                        // 员工来源:CN的人，默认。因为权限小
                        local: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        dev: 'https://laputa-dev-eu.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        test: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        stg: 'https://laputa-stg-eu.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID,
                        prod: 'https://laputa-eu.nioint.com/authorityApply.html?lang=zh&app_id=' + envConfig.APP_ID
                    }
                }
            }
        });
        async function handleApply() {
            var _state_config_state_lang_personDiff, _state_config_state_lang, _state_config;
            if (state.loading) {
                return;
            }
            // 员工来源
            let personDiff = '';
            if (state.isInternational) {
                // 根据员工来源不同，要跳转不同的url
                personDiff = state.isEuropaLabor ? EMPLOYEE_DIFFERENCE_EU : EMPLOYEE_DIFFERENCE_CN;
            } else {
                personDiff = EMPLOYEE_DIFFERENCE_CN;
            }
            // 取出url的path
            const WfUrl = (_state_config = state.config) === null || _state_config === void 0 ? void 0 : (_state_config_state_lang = _state_config[state.lang]) === null || _state_config_state_lang === void 0 ? void 0 : (_state_config_state_lang_personDiff = _state_config_state_lang[personDiff]) === null || _state_config_state_lang_personDiff === void 0 ? void 0 : _state_config_state_lang_personDiff[state.env];
            JsBridge.openUrl(WfUrl);
        }
        async function isEuropaLabor() {
            state.loading = true;
            const res = await apiGetUserDifference();
            if (res && res.isValid()) {
                if (res.data.employeeDifference && res.data.employeeDifference.includes('EU')) {
                    state.loading = false;
                    return true;
                }
            }
            state.loading = false;
            return false;
        }
        async function init() {
            if (state.isInternational) {
                state.isEuropaLabor = await isEuropaLabor();
            }
        }
        init();
        return {
            t,
            state,
            isError,
            // applinkActivateDocUrl,
            handleApply
        };
    }
});
